<script setup lang="ts">
interface PageBuilderProps {
	sections: PageBlock[];
	isTransparentNav?: boolean;
	pageId?: string;
}

const props = withDefaults(defineProps<PageBuilderProps>(), {
	isTransparentNav: false,
});

const validBlocks = computed(() =>
	props.sections.filter(
		(block): block is PageBlock & { collection: string; item: object } =>
			typeof block.collection === 'string' && !!block.item && typeof block.item === 'object',
	),
);

const isFullWidthHero = (block: PageBlock & { collection: string; item: any }) => {
	return block.collection === 'block_hero' && block.item?.layout === 'image_background';
};

const isFullWidthBlock = (block: PageBlock & { collection: string; item: any }) => {
	return isFullWidthHero(block) || 
		(block.collection === 'block_kpis' && block.item?.background_image) ||
		(block.collection === 'block_form' && block.item?.background_image) ||
		block.collection === 'block_wizard';
};

const isFirstBlock = (index: number) => index === 0;

// Ottieni lo stato dello scroll dalla NavigationBar
const hasScrolledPastFirstBlock = useState('hasScrolledPastFirstBlock', () => false);
// Ottieni lo stato del caricamento iniziale dalla NavigationBar
const navbarInitialLoad = useState('navbarInitialLoad', () => true);
</script>

<template>
	<div
		v-for="(block, index) in validBlocks"
		:key="block.id"
		:data-background="block.background"
		:class="{
			// Blocchi non full-width
			'pt-0 pb-4 md:pb-16 transition-[padding-top] duration-300': !isFullWidthBlock(block) && isFirstBlock(index) && isTransparentNav && !hasScrolledPastFirstBlock && !navbarInitialLoad,
			'pt-[80px] pb-4 md:pb-16 transition-[padding-top] duration-300': !isFullWidthBlock(block) && isFirstBlock(index) && isTransparentNav && hasScrolledPastFirstBlock && !navbarInitialLoad,
			'pt-12 pb-4 md:pt-16 md:pb-16': !isFullWidthBlock(block) && isFirstBlock(index) && !isTransparentNav && !navbarInitialLoad,
			'py-16': !isFullWidthBlock(block) && !isFirstBlock(index),
			// Blocchi full-width: quando sono il primo blocco e la navbar è trasparente
			'pt-0 transition-[padding-top] duration-300': isFullWidthBlock(block) && isFirstBlock(index) && isTransparentNav && !hasScrolledPastFirstBlock && !navbarInitialLoad,
			'pt-[80px] transition-[padding-top] duration-300': isFullWidthBlock(block) && isFirstBlock(index) && isTransparentNav && hasScrolledPastFirstBlock && !navbarInitialLoad,
		}"
	>
		<Container v-if="!isFullWidthBlock(block)">
			<BaseBlock :block="block" :page-id="pageId" />
		</Container>
		<BaseBlock v-else :block="block" :page-id="pageId" />
	</div>
</template>
